import PropTypes from 'prop-types';
import React, { createContext, useContext, useState } from 'react';
import AlertToast from './AlertToast';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = (icon, type, text) => {
    const id = new Date().getTime(); // Unique ID for each toast
    setToasts((prevToasts) => [...prevToasts, {
      id, icon, type, text
    }]);

    setTimeout(() => {
      setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
    }, 3000);
  };

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <div className="toast-wrapper">
        {toasts.map((toast) => (
          <AlertToast key={toast.id} icon={toast.icon} type={toast.type} text={toast.text} />
        ))}
      </div>
    </ToastContext.Provider>
  );
}

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired
};
